import React from 'react';
import PropTypes from 'prop-types';
import reduce from 'lodash/reduce';
import take from 'lodash/take';
import classNames from 'classnames';
import { getLocationInfo } from '../../../../utils/venue';

import {
    EventCard,
    CONSUMER_CARD_DEFAULTS,
    parseFollowSignal,
} from '@eb/event-renderer';
import { GRID_TYPE } from '@eb/eds-media-card-content';

import { OnboardingEntry } from '../OnboardingEntry';

import { GA_HOME_FEED_CATEGORY } from '../../../../constants/analytics';

import './ConsumerOnboardingCard.scss';

const _insertOnboardingCard = ({
    cardsComponent,
    eventCardContainerClassName,
    isAuthenticated,
    isInOddLayout,
    onClickOnBoardingCard,
}) => {
    const [card1, card2, card3, ...remainingCards] = cardsComponent;

    let cardsWithOnboarding = [
        card3,
        <OnboardingEntry
            type="standardPurple"
            containerClasses={eventCardContainerClassName}
            key="onboarding-entry"
            isAuthenticated={isAuthenticated}
            onButtonClick={onClickOnBoardingCard.bind(null)}
        />,
    ];

    if (isInOddLayout) {
        cardsWithOnboarding = [
            <OnboardingEntry
                type="standardPurple"
                containerClasses={eventCardContainerClassName}
                key="onboarding-entry"
                isAuthenticated={isAuthenticated}
                onButtonClick={onClickOnBoardingCard.bind(null)}
            />,
            card3,
        ];
    }

    const _cardsComponent = [
        card1,
        card2,
        ...cardsWithOnboarding,
        ...take(remainingCards, remainingCards.length),
    ];

    return _cardsComponent;
};

const ConsumerCards = ({
    //TODO: update api to handle passing custom tracking labels
    bucketKey,
    onViewEvent,
    bucketLayoutConfig,
    cardType,
    eventsGroups,
    isAuthenticated,
    isFreeTab,
    isInOddLayout,
    onClickOnBoardingCard,
    shouldShowOnboardingCard,
}) => {
    const bucketClassNames =
        (bucketLayoutConfig && bucketLayoutConfig.bucketClassNames) || '';

    let cardsComponent = reduce(
        eventsGroups,
        (memo, { events, containerClasses }) => {
            const eventCardsComponents = events.map(
                ({
                    id,
                    minPrice,
                    isFree,
                    isSoldOut,
                    startDate,
                    hideStartDate,
                    numFollowers,
                    venueName,
                    venueAddress,
                    ...cardProps
                }) => {
                    //Once query client properly set up this can be removed
                    const signal = parseFollowSignal(numFollowers);

                    return (
                        <div className={containerClasses} key={id}>
                            <EventCard
                                {...CONSUMER_CARD_DEFAULTS}
                                {...signal}
                                containerSpacingClasses=""
                                eventData={{
                                    ...cardProps,
                                    id,
                                    isFree: !isFreeTab && isFree,
                                    isSoldOut: isSoldOut,
                                    startDate: hideStartDate ? null : startDate,
                                    organizerFollowerCount: numFollowers,
                                }}
                                onClick={onViewEvent.bind(
                                    null,
                                    id,
                                    bucketKey,
                                    numFollowers,
                                )}
                                locationInfo={getLocationInfo(
                                    venueName,
                                    venueAddress,
                                )}
                                minPrice={minPrice}
                                gaCategory={GA_HOME_FEED_CATEGORY}
                                hidePriceDescription={isFreeTab}
                                isAuthenticated={isAuthenticated}
                                affCode="ebdssbcitybrowse"
                            />
                        </div>
                    );
                },
            );

            return [...memo, ...eventCardsComponents];
        },
        [],
    );

    /*
        shouldShowOnboardingCard: Property of bucket defined in tabConfig
    */
    if (shouldShowOnboardingCard) {
        const eventCardContainerClassName = classNames(
            'feed__card-cell',
            'eds-g-cell eds-g-cell--has-overflow eds-g-cell-1-1',
            {
                'eds-g-cell-sm-6-12 eds-g-cell-mn-4-12 eds-g-cell-lg-3-12':
                    cardType === GRID_TYPE,
            },
        );

        cardsComponent = _insertOnboardingCard({
            cardsComponent,
            eventCardContainerClassName,
            isAuthenticated,
            isInOddLayout,
            onClickOnBoardingCard,
        });
    }

    return <div className={bucketClassNames}>{cardsComponent}</div>;
};

ConsumerCards.propTypes = {
    bucketKey: PropTypes.string,
    bucketLayoutConfig: PropTypes.object,
    cardType: PropTypes.string,
    eventsGroups: PropTypes.array,
    isAuthenticated: PropTypes.bool,
    isFreeTab: PropTypes.bool,
    isInOddLayout: PropTypes.bool,
    onClickOnBoardingCard: PropTypes.func,
    shouldShowOnboardingCard: PropTypes.bool,
};

export default ConsumerCards;
